var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPermissions(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 23.973,
    height: 24.052,
    viewBox: "0 0 23.973 24.052",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_20565",
    "data-name": "Group 20565",
    transform: "translate(-1 2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14586",
    "data-name": "Group 14586",
    transform: "translate(1 -2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_16502",
    "data-name": "Path 16502",
    d: "M4.652,0A4.652,4.652,0,1,1,0,4.652,4.652,4.652,0,0,1,4.652,0Z",
    transform: "translate(7.335 2.799)",
    fill: "none",
    stroke: "#6767e0",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_913",
    "data-name": "Path 913",
    d: "M9.436,24.882C4.5,24.882.5,28.406.5,32.753H18.372C18.372,28.406,14.372,24.882,9.436,24.882Z",
    transform: "translate(2.551 -11.828)",
    fill: "none",
    stroke: "#6767e0",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_457",
    "data-name": "Line 457",
    y2: 5,
    transform: "translate(21)",
    fill: "none",
    stroke: "#6767e0",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_458",
    "data-name": "Line 458",
    x1: 5,
    transform: "translate(18.5 2.5)",
    fill: "none",
    stroke: "#6767e0",
    strokeWidth: 1.5
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPermissions);
export default __webpack_public_path__ + "static/media/permissions.724419b72083467843184f09eee2b669.svg";
export { ForwardRef as ReactComponent };